import { computed } from 'vue'

export const useProfileCheck = () => {
    const { $api } = useNuxtApp()
    const { user } = useAuthStore()

    const profileCheck = useState<any>('profileCheck', () => null)
    const isLoading = useState<boolean>('profileCheckLoading', () => false)

    const fetchProfileCompleteInfo = async () => {
        isLoading.value = true
        try {
            const response: any = await $api.profile.getProfileCompleteInfo()
            const { data } = response
            if (data?.value?.data) {
                profileCheck.value = data.value.data
            }
        }
        finally {
            isLoading.value = false
        }
    }

    const isProfileCompleted = computed(
        () => profileCheck.value?.is_profile_completed ?? false,
  )

    const isRejected = computed(() => user.is_rejected)

    const rejectedReason = computed(() => user.rejected_reason)

    const isProfileVerified = computed(() => user.is_profile_verified)

    const updateButtonUrl = computed(() => {
        const pc = profileCheck.value

        if (!pc || pc.is_profile_completed) {
            return '/complete-profile'
        }

        if (!pc.step_one)
            return '/complete-profile'
        if (!pc.step_two)
            return '/complete-profile/future-plan'
        if (!pc.step_three)
            return '/complete-profile/personal-info'
        if (!pc.step_four)
            return '/complete-profile/additional-info'
        if (!pc.step_five)
            return '/complete-profile/experience'

        return '/complete-profile'
    })

    fetchProfileCompleteInfo()

    return {
        profileCheck,
        isProfileCompleted,
        isProfileVerified,
        isLoading,
        isRejected,
        rejectedReason,
        updateButtonUrl,
        fetchProfileCompleteInfo
    }
}
